import React from 'react';
import {observer} from 'mobx-react';
import {EventIcon} from "../../../../../../core/components/event-icon-selector/event-icon";
import styles from "../../styles/match-event.module.scss";
import classNames from "classnames";

export const MatchEventsModuleEventIcon = observer(({event, isPenalties, positionDown}) => {
  const {eventType} = event;

  const iconProps = {
    className: classNames(styles.icon_logo),
    event: eventType,
    width: 16,
    height: 16
  }

  return (
    <div className={classNames(styles.icon, {[styles.penalty_up]: isPenalties && !positionDown}, {[styles.penalty_down]: isPenalties && positionDown})}>
      <EventIcon {...iconProps}/>
    </div>
  )
});